<i18n>
{
  "en": {
    "percentage": "Porcentual increment %",
    "fixed": "Fixed Increment €",
    "groups": "Groups of products:"
  },
  "es": {
    "percentage": "Incremento porcentual %",
    "fixed": "Incremento fijo €",
    "groups": "Grupos de productos:"
  }
}
</i18n>

<template>
  <v-card class="d-flex flex-column px-3">
    <div class="d-flex flex-row justify-space-between align-center">
      <div class="text-h6">{{ ruleName }}</div>
      <v-btn icon @click="onDelete">
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
    </div>
    <div class="py-1 font-weight-bold text-h7">{{ $t('groups')}} {{ ruleGroups }}</div>
    <div class="d-flex flex-row align-center">
      <v-chip v-if="isFixed" x-small class="ma-1">
        <div class="chip-text">{{ $t('fixed') }}</div>
      </v-chip>
      <v-chip v-if="isPercentage" x-small class="mx-1">
        <div class="chip-text">{{ $t('percentage') }}</div>
      </v-chip>
      <v-switch class="ml-auto" v-model="ruleIsActive" dense/>
    </div>
  </v-card>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { MapGetters } from '@core/helpers/decorators';
import { GroupIndexingRule } from '../models';

@Component
@MapGetters(['groupList', 'groupOfProductPricingList'])
export default class GroupIndexingRuleCard extends Vue {
  @Prop({ type: GroupIndexingRule, required: true }) rule;

  ruleIsActive = null;

  get ruleName() {
    const referenceRateName = this.groupList.find((el) => el.code_name === this.rule.referenceGroup)?.translation;
    const changedRateName = this.groupList.find((el) => el.code_name === this.rule.changedGroup)?.translation;
    const sum = (this.rule.fixedIncrement || this.rule.percentageIncrement) > 0 ? '+' : '';
    return `${referenceRateName} -> ${changedRateName} (${sum}${this.isFixed ? `${this.rule.fixedIncrement}€` : `${this.rule.percentageIncrement * 100}%`})`;
  }

  get ruleGroups() {
    if (!this.rule.groupsOfProductsPricing ||
      this.rule.groupsOfProductsPricing.length === 0) return '';

    const names = this.groupOfProductPricingList
      .filter(el => this.rule.groupsOfProductsPricing.includes(el.guid))
      .map(el => el.name);

    return `[${names.join(' / ')}]`;
  }

  get isFixed() {
    return this.rule.fixedIncrement !== null;
  }

  get isPercentage() {
    return this.rule.percentageIncrement !== null;
  }

  onDelete() {
    this.$emit('delete', this.ruleName);
  }

  created() {
    this.ruleIsActive = this.rule.isActive;
  }

  @Watch('ruleIsActive')
  onActiveChange(isActive, oldActive) {
    if (oldActive !== null) {
      const editedRule = new GroupIndexingRule(this.rule.guid, this.rule.percentageIncrement, this.rule.fixedIncrement, isActive, this.rule.changedGroup, this.rule.referenceGroup, this.rule.pointOfSale);
      this.$emit('edit', editedRule);
    }
  }
}

</script>

<style scoped>
.chip-text {
  font-size: 12px;
  color: #545454;
  font-weight: bold;
}
</style>
